/** React */
import React from "react";
import { useTranslation } from "react-i18next";

/** MUI */
import { useTheme } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

// Componente CustomDatePicker
const CustomDatePicker = ({ label, value, onChange, readOnly = true, issearch, isError, ...rest }) => {
    const [t] = useTranslation("global");
    const theme = useTheme(); // Obtén el tema actual

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale={t("language.locale")}
            localeText={{
                clearButtonLabel: t("miscellaneous.clear"),
            }}
        >
            <DatePicker
                {...rest}
                label={label ? (label) : ("")}
                slotProps={{
                    actionBar: {
                        actions: ["clear"],
                        sx: { "& .MuiButtonBase-root": { color: theme.palette.secondary.main }}
                    },
                    desktopPaper: {
                        sx: {
                            borderRadius: '6px',
                            boxShadow: '4px 4px 10px 5px rgba(33, 0, 63, 0.1)',
                        },
                    },
                    textField: {
                        error: isError,
                        fullWidth: true,
                        readOnly: true,
                        sx: {
                            height: issearch ? 42 : 48, // Ajusta la altura aquí
                            '& .MuiInputLabel-root': {
                                color: theme.palette.V080,
                                fontWeight: 600,
                                "&.Mui-disabled": {
                                    color: theme.palette.V050,
                                },
                                "&.Mui-error": {
                                    color: theme.palette.error.main,
                                },
                            },
                            "& .MuiOutlinedInput-root": {
                                height: issearch ? 42 : 48, // Asegura que el contenedor del input tenga la altura correcta
                                backgroundColor: "#fff",
                                borderRadius: "6px",
                                "& fieldset": {
                                    borderColor: theme.palette.V050, // Color del borde
                                },
                                "&:hover fieldset": {
                                    borderColor: theme.palette.V090, // Color del borde en hover
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: theme.palette.V100, // Color del borde en focus
                                },
                                "&.Mui-disabled fieldset": {
                                    borderColor: theme.palette.V010, // Color del borde en desactivado
                                },
                                "&.Mui-error fieldset": {
                                    borderColor: theme.palette.error.main, // Color del borde cuando hay un error
                                },
                                "&.Mui-disabled .MuiSvgIcon-root": {
                                    fill: theme.palette.V050,
                                },
                                "&.Mui-error .MuiSvgIcon-root": {
                                    fill: theme.palette.error.main,
                                }
                            },
                        },
                    },
                    inputAdornment: { sx: { '& .MuiSvgIcon-root': { fill: theme.palette.V090, }}},
                }}
                value={value !== "" ? value : null}
                onChange={onChange}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;
